import { takeEvery, put, call, all, fork } from "@redux-saga/core/effects";
import { FETCH_PAYMENT_METHODS, SET_PAYMENT_METHODS, SET_IS_LOADING_PAYMENT_METHODS } from "redux/constants/portal";
import { geCustomerPaymentMethods } from "layouts/pages/billing/api/paymentMethodsApi";

/***** WORKERS *****/

function* handleFetchPaymentMethods({ payload }) {
   try {
      const { customer_id } = payload;
      yield put({ type: SET_IS_LOADING_PAYMENT_METHODS, payload: true });
      const paymentMethodResponse = yield call(geCustomerPaymentMethods, customer_id);
      yield put({
         type: SET_PAYMENT_METHODS,
         payload: paymentMethodResponse?.resultObject?.data || []
      });
   } catch (error) {
      console.error(error);
   }
   yield put({ type: SET_IS_LOADING_PAYMENT_METHODS, payload: false });
}

/***** WATCHERS *****/

function* watchFetchPaymentMethods() {
   yield takeEvery(FETCH_PAYMENT_METHODS, handleFetchPaymentMethods);
}

export function* rootCustomerBillingSaga() {
   yield all([fork(watchFetchPaymentMethods)]);
}
